import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { Link } from "react-router-dom";
import TableOfContents from "../../components/TableOfContents";
import NotFound from "../NotFound";

function Blog() {
    const { blogSlug } = useParams(); // Get the blogSlug from the URL
    const [blog, setBlog] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Fetch the blog data
        axios
            .get(`${process.env.REACT_APP_API_URL}/blog/${blogSlug}`)
            .then((response) => {
                setBlog(response.data); // Set the blog data
            })
            .catch((err) => {
                console.error(err);
                setError("Blog bulunamadı!");
            });
    }, [blogSlug]);

    if (!blog) return null; // Return early if the blog data is not loaded yet

    if (error)
        return (
            <NotFound />
        );

    return (
        <>
            <Helmet>
                <title>{blog.title} - Legalbul</title>
                <meta name="description" content={blog.description} />
                <link
                    rel="canonical"
                    href={`${window.location.origin}${window.location.pathname}`}
                />
                <meta property="og:title" content={blog.title} />
                <meta property="og:description" content={blog.description} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:url"
                    content={`http://www.legalbul.com/blog/${blogSlug}`}
                />
                <meta property="og:image" content={blog.preview_img_src} />
                <meta property="og:site_name" content="Legalbul" />
                <meta property="og:locale" content="tr_TR" />
                <meta property="og:published_time" content={blog.last_modified} />
            </Helmet>

            <Header />
            <div className="blog-section">
                <section className="container my-5 bg-white shadow-sm p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/blog">Bloglar</Link>
                        </li>
                        <li>{blog.title}</li>
                    </ol>

                    <ul className="blog-meta-list">
                        <li className="blog-meta-item d-inline mx-2">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="text-orange d-inline mx-1"
                                viewBox="0 0 16 16"
                            >
                                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" />
                            </svg>
                            {blog.last_modified}
                        </li>
                    </ul>

                    <TableOfContents />

                    <h1 className="mt-3">{blog.title}</h1>
                    <div
                        className="blog-texts"
                        dangerouslySetInnerHTML={{ __html: blog.content }}
                    ></div>
                </section>
            </div>
            <Footer showSSS={true} />
        </>
    );
}

export default React.memo(Blog);
